import Report from './Report'

export default class Reports {
  constructor() {
    this.reports = []
  }

  // load all reports from destination config file
  // destination => Type: string
  async initReports(destinationSlug) {
    try {
      // load reports from config file
      const reportsFile = await import(
        `../../../reportConfiguration/${destinationSlug}.js`
      )
      const reports = reportsFile.default

      // iterate reports
      for (let report in reports) {
        this.reports.push(new Report(reports[report]))
      }
    } catch (e) {
      /* no custom reports for this destination */
    }
  }

  getReports() {
    return this.reports
  }
}
